import Vue from 'vue'
import VueRouter from 'vue-router'
import _ from 'lodash'
import store from '@/store'
import {
  getToken
} from '@/utils/cookie'
import {
  message
} from 'ant-design-vue/es'

Vue.use(VueRouter)

let routes = []

const contexts = require.context('./routes', true, /\.js$/)
contexts.keys().forEach(key => {
  const modRoutes = contexts(key).default
  if (!key.includes('index') && _.isArray(modRoutes)) {
    routes = routes.concat(modRoutes)
  }
})

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  let token = window.sessionStorage.getItem('token')
  if (token) {
    if (to.path === '/login') {
      next('/')
    } else {
      store.dispatch('GetInfo', token).then(res => {
        if (res.state === 'INIT') {
          next(`/personCenter/${res.id}?state=${res.state}`)
        }
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
  if (!getToken() && to.name === 'product') { // 没有登录不能进详情页
    message.warning('请先登录')
    next({
      path: '/login',
      query: {
        id: to.params.id
      }
    })
  }
  next()
})

export default router
